import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeliveryScheduleCollectiveEditCompleteTemplate } from 'components/Templates'

const DeliveryScheduleCollectiveEditComplete: FC = () => {
  return (
    <Layout title={`完了 | お届け可能日を一括設定`}>
      <DeliveryScheduleCollectiveEditCompleteTemplate />
    </Layout>
  )
}

export default DeliveryScheduleCollectiveEditComplete
